import AnalyticsManager from '../AnalyticsManager';
import GoogleAnalyticsProvider from '../providers/GoogleAnalyticsProvider';

/**
 * Backward-compatible wrapper for the original GaGtag class
 * Maintains the original API while using the new analytics system
 *
 * @deprecated Use AnalyticsManager with providers directly for new code
 */
export default class GaGtag {
  constructor() {
    this.analyticsManager = new AnalyticsManager();
    this.googleProvider = new GoogleAnalyticsProvider();

    this.analyticsManager.addProvider(this.googleProvider);

    this.analyticsManager.initialize().then((results) => {
      if (results.failed.includes('google-analytics')) {
        console.warn(
          'Google Analytics initialization failed in backward compatibility mode',
        );
      }
    });

    // Store reference to track submissions for query string generation
    this.formData = null;
    this.submission = null;
  }

  /**
   * Build event submission data (legacy method)
   * @returns {Object}
   */
  buildEventSubmission() {
    if (!this.formData) {
      return {};
    }

    return this.googleProvider.transformEventData(this.formData);
  }

  /**
   * Submit an analytics event
   * @param {FormData} formData - Form data
   * @param {string} eventName - Event name (default: 'form_submit')
   */
  submitEvent(formData, eventName = 'form_submit') {
    this.formData = formData;
    this.submission = this.buildEventSubmission();

    console.debug('Submission event attributes', this.submission);

    // Track event using the new system
    this.analyticsManager.trackEvent(eventName, formData);
  }

  /**
   * Submit a suspect/spam event
   * @param {FormData} formData - Form data
   */
  submitSuspectEvent(formData) {
    this.submitEvent(formData, 'spam_submission');
  }

  /**
   * Get form data value (legacy method)
   * @param {string} key - Form field key
   * @returns {string}
   */
  getFormData(key) {
    if (!this.formData) {
      return '(not set)';
    }

    const data = this.formData.get(key);
    return !data || data === '' ? '(not set)' : data;
  }

  /**
   * Set query string (legacy method)
   * Called automatically by submitEvent for backward compatibility
   */
  setQueryString() {
    // This is handled automatically by the Google Analytics provider
    // but we call it to ensure the query string is generated
    this.googleProvider.generateQueryString();
  }

  /**
   * Get query string for redirects
   * @returns {string}
   */
  getQueryString() {
    return this.googleProvider.getQueryString();
  }

  /**
   * Get access to the underlying analytics manager
   * @returns {AnalyticsManager}
   */
  getAnalyticsManager() {
    return this.analyticsManager;
  }

  /**
   * Get access to the Google Analytics provider
   * @returns {GoogleAnalyticsProvider}
   */
  getGoogleProvider() {
    return this.googleProvider;
  }
}
